/**
 * #648 — after a turn ENDS, a permission / question card whose request the server no longer holds open (answered in
 * another tab, closed with its turn, superseded) must not stay rendered with live Allow / Deny buttons. The server's
 * open set (`/pending`'s `openRequestIds`, the durable suspension rows — a suspended turn's cards ARE open) decides.
 *
 * Only while the session is idle: a turn running again may have published a fresh card a moment before the server
 * recorded it, and dropping that would lose a prompt. Unchanged state is returned as-is (no re-render).
 */
export interface CardState {
  status: string
  pendingPermissions: ReadonlyArray<{ id: string }>
  pendingQuestions: ReadonlyArray<{ id: string }>
}

export function dropStaleCards<S extends CardState>(prev: S, openRequestIds: readonly string[]): S {
  if (prev.status !== 'idle') return prev
  const open = new Set(openRequestIds)
  const perms = prev.pendingPermissions.filter((p) => open.has(p.id))
  const questions = prev.pendingQuestions.filter((q) => open.has(q.id))
  if (perms.length === prev.pendingPermissions.length && questions.length === prev.pendingQuestions.length) return prev
  return { ...prev, pendingPermissions: perms, pendingQuestions: questions }
}
